export default __webpack_public_path__ + "static/portrait-102d8cc79704438375ffb3c621e95d43.png";